import 'css-chunksrc/client/pages/occupancyPage/table/projectsDetail/loaderRow/styles.scss';export default {
  "row": "_row_16hff_1",
  "projectCell": "_projectCell_16hff_6",
  "icon": "_icon_16hff_22",
  "name": "_name_16hff_29",
  "cell": "_cell_16hff_34",
  "cellBar": "_cellBar_16hff_46"
};